import { useFormContext } from "react-hook-form";

import { FieldSetInputProps } from "components/voc";
import styled from "styled-components";

type FieldCheckBoxProps = FieldSetInputProps & { labelText?: string };

const FieldCheckBoxStyled = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4rem;
  height: 3.8rem;
  margin: 0.2rem;
  border: 1px solid #dadada;
  color: #222;
  font-size: 1.3rem;
  line-height: 1.6rem;
  text-align: center;

  input[type="checkbox"]:checked + label {
    width: 100%;
    height: 100%;
    background-color: #454557;
    color: #fff;
    font-weight: 700;
    line-height: 3.6rem;
  }
`;

const FieldCheckBox = ({ name, labelText, ...props }: FieldCheckBoxProps) => {
  const { register } = useFormContext();
  return (
    <>
      <FieldCheckBoxStyled>
        <input {...register(name!)} {...props} />
        <label htmlFor={props.id}>{labelText}</label>
      </FieldCheckBoxStyled>
    </>
  );
};

export default FieldCheckBox;
